import React from 'react';
import LegalLayout, { LegalSection } from '../components/layout/LegalLayout';

export default function DeleteAccountPage() {
  return (
    <LegalLayout title="Suppression de Compte" lastUpdated="Mars 2026">
      <p className="italic text-linx_text-muted">
        Cette page décrit la procédure à suivre pour demander la suppression de votre compte et de vos données personnelles sur l'application <strong>LinxExpress</strong>, produit développé et exploité par <strong>AGODEV SOLUTIONS SARL</strong>.
      </p>

      <LegalSection title="1. Application et Éditeur">
        <p>
          <strong>LinxExpress</strong> est une plateforme de transport développée par <strong>AGODEV SOLUTIONS SARL</strong> (RNE : B509612026 – MF : 1958385L), avenue Habib Bourguiba, Teboulbou Gabès 6032, Tunisie.
        </p>
        <p>
          La plateforme est disponible via deux applications mobiles : l'application <em>Client</em> et l'application <em>Chauffeur</em>, disponibles sur Google Play et App Store.
        </p>
      </LegalSection>

      <LegalSection title="2. Comment Demander la Suppression de Votre Compte">
        <p>Vous pouvez demander la suppression de votre compte de l'une des deux façons suivantes :</p>

        <h3 className="font-semibold text-linx_text-primary mt-4 mb-2">Option A — Depuis l'Application</h3>
        <ol className="list-decimal pl-6 space-y-1.5">
          <li>Ouvrez l'application <strong>LinxExpress</strong> (Client ou Chauffeur).</li>
          <li>Accédez à votre <strong>Profil</strong> (icône en bas de l'écran).</li>
          <li>Appuyez sur <strong>Paramètres</strong>.</li>
          <li>Sélectionnez <strong>Supprimer mon compte</strong>.</li>
          <li>Confirmez votre identité (mot de passe ou validation Google/OAuth).</li>
          <li>Confirmez la suppression en appuyant sur <strong>Confirmer</strong>.</li>
        </ol>

        <h3 className="font-semibold text-linx_text-primary mt-4 mb-2">Option B — Par E-mail</h3>
        <p>
          Si vous n'avez plus accès à l'application, envoyez une demande par e-mail à :{' '}
          <a
            href="mailto:contact@agodevsolutions.com"
            className="text-accent-blue underline hover:opacity-80 transition-opacity"
          >
            contact@agodevsolutions.com
          </a>
        </p>
        <p>Précisez dans votre e-mail :</p>
        <ul className="list-disc pl-6 space-y-1.5 mt-2">
          <li>Votre nom complet</li>
          <li>L'adresse e-mail ou le numéro de téléphone associé à votre compte</li>
          <li>Le type de compte : <em>Client</em> ou <em>Chauffeur</em></li>
          <li>La mention explicite : <em>« Je demande la suppression de mon compte LinxExpress »</em></li>
        </ul>
        <p className="mt-3">
          Nous traiterons votre demande dans un délai de <strong>30 jours</strong> à compter de sa réception.
        </p>
      </LegalSection>

      <LegalSection title="3. Données Supprimées">
        <p>Lors de la suppression de votre compte, les données suivantes sont <strong>anonymisées ou effacées</strong> :</p>
        <ul className="list-disc pl-6 space-y-1.5 mt-2">
          <li>Nom complet, adresse e-mail et numéro de téléphone</li>
          <li>Photo de profil</li>
          <li>Adresse personnelle</li>
          <li>Documents de vérification (CIN, permis, carte grise — pour les chauffeurs)</li>
          <li>Préférences et paramètres de l'application</li>
          <li>Tokens de session et d'authentification</li>
        </ul>
        <p className="mt-3">
          Votre compte sera bloqué immédiatement et ne pourra plus être réactivé ni réutilisé.
        </p>
      </LegalSection>

      <LegalSection title="4. Données Conservées">
        <p>
          Certaines données sont conservées après la suppression du compte, conformément aux obligations légales et réglementaires tunisiennes :
        </p>
        <ul className="list-disc pl-6 space-y-1.5 mt-2">
          <li>Historique des courses et des transactions (données anonymisées)</li>
          <li>Notes et avis laissés sur la plateforme (anonymisés)</li>
          <li>Données comptables et financières liées aux paiements</li>
          <li>Journaux de sécurité et d'audit, en cas d'obligation légale ou de litige en cours</li>
        </ul>
      </LegalSection>

      <LegalSection title="5. Durée de Conservation">
        <p>Les données opérationnelles anonymisées et les données financières sont conservées pendant une durée maximale de <strong>5 ans</strong> à compter de la date de suppression du compte, conformément aux exigences légales et comptables en vigueur en Tunisie.</p>
        <p className="mt-2">
          En cas de litige actif, la suppression peut être temporairement suspendue jusqu'à résolution de celui-ci.
        </p>
      </LegalSection>

      <LegalSection title="6. Remarque Concernant les Réservations en Cours">
        <p>
          Si vous avez des réservations <strong>en cours ou en attente</strong> au moment de la demande, la suppression sera bloquée jusqu'à leur finalisation. Vous devrez clôturer ou annuler toutes les courses actives avant de procéder à la suppression.
        </p>
      </LegalSection>

      <LegalSection title="7. Contact">
        <p>Pour toute question relative à la suppression de compte ou à vos données personnelles, contactez-nous à :</p>
        <ul className="list-none pl-0 space-y-1 mt-2">
          <li>
            📧 E-mail :{' '}
            <a
              href="mailto:contact@agodevsolutions.com"
              className="text-accent-blue underline hover:opacity-80 transition-opacity"
            >
              contact@agodevsolutions.com
            </a>
          </li>
          <li>🏢 AGODEV SOLUTIONS SARL, avenue Habib Bourguiba, Teboulbou Gabès 6032, Tunisie</li>
        </ul>
      </LegalSection>
    </LegalLayout>
  );
}
